import { ReportOverview } from "./reportOverview";
import { performanceDashboard } from "./performanceDashboard";
import { revenueTrafficOpportunity } from "./revenueTrafficOpportunity";
import { uxDashboard } from "./uxDashboard";
import { competitorPerformance } from "./competitorPerformance";
import { howCustomersSearch } from "./howCustomersSearch";
import { featureFormat } from "./featureFormat";

export const sections = (props) => [
  {
    id: "report-overview",
    title: "Report Overview",
    sections: ReportOverview(props),
    className: "report-overview-section",
  },
  {
    id: "performance-dashboard",
    title: "Performance Dashboard",
    sections: performanceDashboard(props),
    className: "primary-pink",
    description: (
      <>
        <p>
          Breaking out the biggest opportunities from a revenue and rankings
          perspective.
        </p>
        <p>Questions Answered:</p>
        <ul>
          <li>What are the best & worst ranking categories?</li>
          <li>What are the biggest revenue opportunities?</li>
          <li>How are my keywords broken out by intent?</li>
          <li>What pages are my keywords ranking for?</li>
          <li>What is the overall revenue opportunity?</li>
        </ul>
      </>
    ),
  },
  {
    id: "revenue-traffic-opportunity",
    title: "Revenue & Traffic Opportunity",
    sections: revenueTrafficOpportunity(props),
    className: "primary-purple",
    description: (
      <>
        <p>
          Identifying the biggest traffic & revenue opportunities by looking at
          position 1, top 3 & top 5
        </p>
        <p>Questions Answered:</p>
        <ul>
          <li>
            Can you tell me what’s a realistic target we could aim for outside
            of position 1?
          </li>
          <li>
            What are the biggest revenue opportunities broken down by position?
          </li>
          <li>How can I build business cases to get recommendations live?</li>
        </ul>
      </>
    ),
  },
  {
    id: "ux-dashboard",
    title: "UX Dashboard",
    sections: uxDashboard(props),
    className: "primary-turquoise",
    description: (
      <>
        <p>Creating a more efficient and profitable user journey.</p>
        <p>Questions Answered:</p>
        <ul>
          <li>
            Can you tell me what the bounce rate is for my categories and pages?
          </li>
          <li>
            How is conversion rate performing across my website and how do I
            prioritise what I should do?
          </li>
          <li>Can you break out the performance by page template?</li>
        </ul>
      </>
    ),
  },
  {
    id: "competitor-performance",
    title: "Competitor Performance",
    sections: competitorPerformance(props),
    className: "primary-yellow",
    description: (
      <>
        <p>
          How your site is ranking compared to competitors and looks at the
          traffic/revenue breakdown to identify who is winning across the
          keyword universe
        </p>
        <p>Questions Answered:</p>
        <ul>
          <li>How much traffic are competitors driving from SEO?</li>
          <li>
            Is there a way to show a keyword breakdown for where competitors are
            winning and losing?
          </li>
          <li>
            Can you break down how competitors are doing by product category?
          </li>
        </ul>
      </>
    ),
  },
  {
    id: "how-customers-search",
    title: "How Customers Search",
    sections: howCustomersSearch(props),
    className: "primary-blue",
    description: (
      <>
        <p>
          How your customers are searching on Google and what trends we can
          identify from the last 24 months.
        </p>
        <p>Questions Answered:</p>
        <ul>
          <li>
            Can you tell me when our keywords peak so we can plan with content
            creation?
          </li>
          <li>What are the biggest trending categories?</li>
          <li>What product categories have the biggest search volumes?</li>
        </ul>
      </>
    ),
  },
  {
    id: "feature-format",
    title: "Feature Format",
    sections: featureFormat(props),
    className: "primary-green",
    description: (
      <>
        <p>
          What SERP features are appearing on Google and who are owning these
          SERP features.
        </p>
        <p>Questions Answered:</p>
        <ul>
          <li>
            What are all the various SERP features that are appearing on Google
            for our site?
          </li>
          <li>
            What websites are owning these SERP features and what do we need to
            action?
          </li>
          <li>
            Outside of SEO, what platforms such as Amazon & YouTube offer the
            best opportunity?
          </li>
        </ul>
      </>
    ),
  },
];
